/*
 There are a couple things that coffeescript would generate for you, and thus
 which are duplicated in misc formerly-coffeescript modules. They go here.
 */

export function __range__(left, right, inclusive) {
    const range = [];
    const ascending = left < right;
    const end = !inclusive ? right : ascending ? right + 1 : right - 1;
    for (let i = left; ascending ? i < end : i > end; ascending ? i++ : i--) {
        range.push(i);
    }
    return range;
}



// WEBPACK FOOTER //
// ./app/lib/decaf.js